import { Reveal } from "./Reveal";

const CHAPTERS = [
  {
    num: "01",
    title: "Excavation & Earthworks",
    desc: "Bulk dig-outs, site levelling, trenching and muck-away — machine work done clean, level and on programme.",
    tags: ["Bulk dig", "Levelling", "Muck-away"],
  },
  {
    num: "02",
    title: "Foundations & Concrete",
    desc: "Strip and raft foundations, reinforced slabs, oversites and concrete pours for extensions and new builds.",
    tags: ["Strip footings", "Rafts", "Reinforced slabs"],
  },
  {
    num: "03",
    title: "Drainage & Soakaways",
    desc: "New foul and surface water systems, land drains, soakaways and attenuation — designed and installed to regs.",
    tags: ["Foul & surface", "Land drains", "Attenuation"],
  },
  {
    num: "04",
    title: "Drain Repairs & CCTV",
    desc: "CCTV surveys, root cutting, patch lining and collapsed drain replacement. We find it, then we fix it.",
    tags: ["CCTV surveys", "Patch lining", "Replacements"],
  },
  {
    num: "05",
    title: "Site Clearance & Prep",
    desc: "Vegetation clearance, demolition of outbuildings, hardcore crushing and full plot preparation.",
    tags: ["Clearance", "Demolition", "Plot prep"],
  },
];

export const Services = () => (
  <section id="services" data-testid="services-section" className="px-5 py-24 md:px-12 md:py-32">
    <div className="mb-14 grid gap-8 md:mb-20 md:grid-cols-12 md:items-end">
      <div className="md:col-span-7">
        <Reveal>
          <p className="mb-4 font-mono text-[11px] uppercase tracking-[0.25em] text-ember">[ Capabilities ]</p>
          <h2 className="font-display text-5xl uppercase leading-[0.85] tracking-tight text-white md:text-7xl">
            What we<br />do best
          </h2>
        </Reveal>
      </div>
      <Reveal delay={0.15} className="md:col-span-5">
        <p className="max-w-sm text-sm leading-relaxed text-steel md:ml-auto">
          One machine, one team, one point of contact. From the first spade in
          the ground to the finished job — we handle the whole lot.
        </p>
      </Reveal>
    </div>

    <div data-testid="services-chapters">
      {CHAPTERS.map((ch, i) => (
        <Reveal key={ch.num} delay={i * 0.04}>
          <div
            data-testid={`service-chapter-${ch.num}`}
            className="group grid grid-cols-1 gap-4 border-t border-line py-8 transition-colors duration-300 hover:bg-white/[0.02] md:grid-cols-12 md:items-baseline md:gap-6 md:py-10"
          >
            <span className="font-mono text-sm tracking-[0.2em] text-ember md:col-span-1">[{ch.num}]</span>
            <h3 className="font-display text-3xl uppercase leading-none tracking-tight text-white transition-colors duration-300 group-hover:text-ember md:col-span-4 md:text-4xl">
              {ch.title}
            </h3>
            <p className="text-sm leading-relaxed text-steel md:col-span-4">{ch.desc}</p>
            <div className="flex flex-wrap gap-2 md:col-span-3 md:justify-end">
              {ch.tags.map((t) => (
                <span key={t} className="border border-line px-3 py-1 font-mono text-[10px] uppercase tracking-[0.15em] text-steel transition-colors duration-300 group-hover:border-ember/50">
                  {t}
                </span>
              ))}
            </div>
          </div>
        </Reveal>
      ))}
      <div className="border-t border-line" />
    </div>
  </section>
);
